import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './Divider.module.scss';
export const Divider = (props)=>{
    const { skin = 'default', margin = 24, orientation = 'horizontal', className, size, testId } = props;
    const isHorizontal = orientation === 'horizontal';
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles[skin], styles[orientation], className),
        "data-testid": testId,
        style: {
            [isHorizontal ? 'width' : 'height']: size,
            margin: isHorizontal ? "".concat(margin, "px 0") : "0 ".concat(margin, "px")
        }
    });
};
